import React, { useEffect, useState } from "react";
import "../css/Authentication.css";
import LoginForm from "./LoginForm";
// import SignupForm from "./SignupForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { useMediaQuery } from "react-responsive";
import CuFrontLogo from "./CuFrontLogo";
import { FaArrowLeft } from "react-icons/fa";
// import ClinicLogo from "./ClinicLogo";
// import { useAtom } from "jotai";
// import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { AuthSideImages } from "../../../cufront-assets/images/Images";
import { FRAME_24, PHONE_FRAME } from "../../../_helper/constant/constant";

const Authentication = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  // const [clinic] = useAtom(clinicAtom);
  const md = useMediaQuery({ query: "(min-width:1025px)" });
  const sm = useMediaQuery({ query: "(min-width:580px)" });

  const [steps, setSteps] = useState(1);

  const prevStepsHandler = () => {
    setSteps((prev) => prev - 1);
  };

  useEffect(() => {
    if (steps == 1) {
      setIsForgotPassword(false);
    }
  }, [steps]);

  //(steps, isForgotPassword, "isForgotPassword");

  return (
    <div className="auth-layout">
      <div className="auth-container">
        <div className="auth-left">
          {isForgotPassword && (
            <FaArrowLeft
              className="cursor-pointer"
              onClick={prevStepsHandler}
            />
          )}
          {/* <ClinicLogo /> */}
          {/* {!isForgotPassword &&  isSignup && (
            <SignupForm setIsSignup={setIsSignup} />
          )} */}
          {!isForgotPassword && !isSignup && (
            <LoginForm
              setIsSignup={setIsSignup}
              setIsForgotPassword={setIsForgotPassword}
              setSteps={setSteps}
            />
          )}
          {isForgotPassword && (
            <ForgotPasswordForm
              setIsSignup={setIsSignup}
              setIsForgotPassword={setIsForgotPassword}
              setSteps={setSteps}
              steps={steps}
            />
          )}
          <CuFrontLogo />
        </div>
        {md && (
          <div className="auth-right">
            <img src={AuthSideImages.FRAME_16} />
          </div>
        )}
      </div>
      {!md && (
        <img className="auth-background" src={sm ? FRAME_24 : PHONE_FRAME} />
      )}
    </div>
  );
};

export default Authentication;
